<h2
  mat-dialog-title
  mat-dialog-draggable-title
  style="margin-bottom: 0px !important"
>
<!--  <span>{{ "form.select_procedure_full" | translate }}</span>-->
  <span>Cấu hình người phê duyệt của {{data.customer.name}}</span>
</h2>
<mat-divider></mat-divider>
<div class="mat-table-container" style="margin-top: 10px;">
  <nz-table #rowsTable nzBordered [nzData]="dataSource" [nzShowPagination]="false" id="myTable"
            [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
    <thead>
    <tr>
      <th class="text-center" nzWidth="7%">
        {{'enterprise_contract.panel_document.table_parties.header.order' | translate}}
      </th>
      <th class="text-center"  >
        {{'import_file.table_detail.fulName' | translate}}*
      </th>
      <th class="text-center" nzWidth="15%" >
        {{'form.phone' | translate}}*
      </th>
      <th class="text-center" nzWidth="20%" >
        {{'form.email' | translate}}*
      </th>
      <th class="text-center" nzWidth="15%">
        {{'form.CCCD' | translate}}*
      </th>
      <th class="text-center" nzWidth="10%">
        {{'form.aprrove_CTS' | translate}}
      </th>
      <th class="text-center" nzWidth="10%">
        {{'form.show_image' | translate}}
      </th>
      <th class="text-center" nzWidth="3%">
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of dataSource; let i = index;">
      <td class="text-center" [ngClass]="{'highlight':data.checkFocusSTT}"><input (focusout)="data.STT = data.STT.trim()"  matInput autocomplete="off"
                                     type="number" [min]="1"  [max]="999"  [(ngModel)]="data.STT" maxlength="200"(focus)="clickInput('checkFocusSTT',i)" (blur)="clickInput2('checkFocusSTT',i)"
                                     [placeholder]="'placeholder.enter_no' | translate" (keypress)="onlyNumbers($event)"></td>
      <td [ngClass]="{'highlight':data.checkFocusName}"  >
        <input (focusout)="data.name = data.name.trim()" matInput autocomplete="off" [ngClass]="{'classPlaceholder':!data.name && data.validateForm}"
               type="text"  [(ngModel)]="data.name" maxlength="200" (focus)="clickInput('checkFocusName',i)" (blur)="clickInput2('checkFocusName',i)"
               [title]="data.name ? '' : ('approved.name_requied' | translate )"
               [placeholder]="'placeholder.enter_name' | translate">
      </td>
      <td class="text-center" [ngClass]="{'highlight':data.checkFocusPhone}">
        <input (focusout)="data.phoneNumber = data.phoneNumber.trim()" matInput autocomplete="off" [ngClass]="{'classPlaceholder':!data.phoneNumber && data.validateForm ,'colorText': data.checkPhone || !regxPhone.test(data.phoneNumber)}"
               type="text"  [(ngModel)]="data.phoneNumber" [maxlength]="phoneMaxLength" [pattern]="phonePattern2" (focus)="clickInput('checkFocusPhone',i)" (blur)="clickInput2('checkFocusPhone',i)"
               [title]="data.phoneNumber ? (data.checkPhone ? ('lading_page.main.contact.validate_form.phone_format' | translate ):'') : ('validation.phone_number_re' | translate )"
               [placeholder]="'placeholder.enter_phone' | translate" (keypress)="onlyNumbers($event)">
<!--        <input (focusout)="data.phoneNumber = data.phoneNumber.trim()" matInput autocomplete="off"-->
<!--               type="text" [(ngModel)]="data.phoneNumber" maxlength="20"-->
<!--               (focus)="clickInput('checkFocusPhone',i)" (blur)="clickInput2('checkFocusPhone',i)"-->
<!--               [placeholder]="'placeholder.enter_phone' | translate"-->
<!--               pattern="[0-9]*">-->
      </td>
      <td [ngClass]="{'highlight':data.checkFocusMail}">
        <input [ngClass]="{'colorText':data.checkMail || data.checkTrung ,'classPlaceholder':!data.email && data.validateForm}" (focusout)="data.email = data.email.trim()" matInput autocomplete="off"
               type="text" [title]= "data.email ? (data.checkMail ? ('lading_page.main.contact.validate_form.email_format' | translate) : (data.checkTrung ? ('approved.email_duplicate' | translate ) : '')) : ('approved.email_requied' | translate )"
               [(ngModel)]="data.email" maxlength="200" (focus)="clickInput('checkFocusMail',i)" (blur)="clickInput2('checkFocusMail',i,data.email)"
               [placeholder]="'placeholder.enter_mail' | translate">
<!--        <input  *ngIf="data.checkMail" class="colorText" (focusout)="data.email = data.email.trim()" matInput autocomplete="off" nz-tooltip [nzTooltipTitle]="data.email"-->
<!--               type="text"  [(ngModel)]="data.email" maxlength="200" (focus)="clickInput('checkFocusMail',i)" (blur)="clickInput2('checkFocusMail',i,data.email)"-->
<!--               [placeholder]="'placeholder.enter_mail' | translate">-->
<!--        <span style="color: red">sai dinh dang</span>-->
      </td>
      <td class="text-left" [ngClass]="{'highlight':data.checkFocusCertificate}">
        <input [ngClass]="{'classPlaceholder':!data.taxCode && data.validateForm,'colorText': data.checkCertificate}" (focusout)="data.taxCode = data.taxCode.trim()" matInput autocomplete="off"
               type="text"  [(ngModel)]="data.taxCode" maxlength="20" (focus)="clickInput(data,i)" (blur)="clickInput2(data,i)"
               [title]="data.taxCode ? (data.checkCertificate ?  ('approved.requeid_CCCD_format' | translate ): '') :  ('approved.requeid_CCCD_to_CTS' | translate )"
               [placeholder]="'placeholder.enter_certificate' | translate" >
      </td>
      <td class="text-center">
<!--        <mat-checkbox color="primary" [(ngModel)]="data.CTS" (change)="changeCheckBox(i)" name="check1" [ngModelOptions]="{standalone: true}">-->
<!--          &lt;!&ndash;                      (change)="onSelect(element)">&ndash;&gt;-->
<!--        </mat-checkbox>-->
        <label nz-checkbox [(ngModel)]="data.CTS" [ngModelOptions]="{ standalone: true }" (change)="changeCheckBox(i)"
               style="color:rgba(0, 0, 0, 0.87) !important; "
        ></label>
      </td>
      <td class="text-center">
        <label nz-checkbox [(ngModel)]="data.image" [ngModelOptions]="{ standalone: true }" [disabled]="!data.CTS"
               style="color:rgba(0, 0, 0, 0.87) !important; "
        ></label>
<!--        <mat-checkbox color="primary" [(ngModel)]="data.image" [disabled]="!data.CTS" name="check2" [ngModelOptions]="{standalone: true}" >-->

<!--        </mat-checkbox>-->
      </td>
      <td class="text-center">
        <a *ngIf="this.dataSource.length != 1" nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
          'popup.confirm_delete_user_approve' | translate
        }}" (nzOnConfirm)="onclickDelete(data.userId)"
           nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
          <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
        </a>
        <ng-template #iconDel>
          <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
        </ng-template>
      </td>
    </tr>
    </tbody>
  </nz-table>
</div>
<!--<div>-->
<!--  <mat-icon-->
<!--    class="mr-0 text-center"-->
<!--    style="color: rgb(206 0 43); font-size: x-large; cursor: pointer"-->
<!--    matTooltip="{{ 'button.add_approver' | translate }}"-->
<!--    (click)="addCustomer()"-->
<!--  >add_circle_outline</mat-icon-->
<!--  >-->
<!--  <label>{{'button.add_approver' | translate}}</label>-->
<!--&lt;!&ndash;  <button (click)="addCustomer()"><mat-icon class="mr-0">add_circle_outline</mat-icon></button>&ndash;&gt;-->
<!--</div>-->
<div class=" mat-panel-title mat-panel-title_custom font-color-blue"  style="padding-left: 10px;">
  <a style="display: inline-block;font-size: 1em;color: inherit;text-decoration: none;margin: 0;padding: 0;  cursor: pointer;"
     (click)="addCustomer()">  {{'button.add_approver' | translate}} </a>
  <div class="d-flex">
    <mat-icon class="mr-0 ml-1 text-primary" (click)="addCustomer()" style=" font-size: x-large; cursor: pointer"  matTooltip="{{ 'button.add_approver' | translate }}"
    >add_circle_outline
    </mat-icon>
  </div>
  <!--              matTooltip="{{ 'procedure.choose_procedure_private' | translate }}"-->
</div>
<mat-divider></mat-divider>
<div class="text-center mt-3">
  <button mat-stroked-button color="primary" class="mr-3"
          (click)="onNoClick()">
    <mat-icon class="mr-0">cancel</mat-icon>{{ "button.cancel" | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="confirm()">
    <mat-icon class="mr-0">save</mat-icon>
    <span>{{"button.choose" | translate}}</span>
  </button>
</div>
